import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "careerHistoryRegisterTab" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_InfoBox = _resolveComponent("InfoBox")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_AutoCompleteField = _resolveComponent("AutoCompleteField")!
  const _component_ComboBoxField = _resolveComponent("ComboBoxField")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_DateInputField = _resolveComponent("DateInputField")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_TextAreaField = _resolveComponent("TextAreaField")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.model.Id == "" ? "Add Career History" : "Edit Career History"), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_form, {
              ref: "frmRegister",
              modelValue: _ctx.valid,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.valid) = $event)),
              "lazy-validation": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_InfoBox, { title: "Add Your Career History here! Include your previous relevant experience, and your current role (if currently employed)" })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      md: "4",
                      cols: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_AutoCompleteField, {
                          readonly: _ctx.isHiringmanager,
                          dense: "",
                          label: "Role",
                          placeholder: "Select Role ...",
                          "item-title": "Name",
                          "item-value": "id",
                          rules: [_ctx.validations.required, _ctx.validations.arrayMinLength(1)],
                          showRequired: "",
                          items: _ctx.jobRoles,
                          modelValue: _ctx.selectedJobRole,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedJobRole) = $event)),
                          outlined: ""
                        }, null, 8, ["readonly", "rules", "items", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "pb-0"
                    }, {
                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                        _createElementVNode("span", { class: "f-body-1" }, "Job Title", -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      md: "4",
                      cols: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ComboBoxField, {
                          readonly: _ctx.isHiringmanager && !_ctx.selectedJobRole,
                          id: "jobTitle",
                          clearable: "",
                          placeholder: "Select Job Title ...",
                          items: _ctx.jobTitles,
                          outlined: "",
                          dense: "",
                          "item-title": "Name",
                          "item-value": "id",
                          rules: [_ctx.validations.required],
                          "closable-chips": "",
                          modelValue: _ctx.selectedJobTitle,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedJobTitle) = $event)),
                          returnObject: false
                        }, null, 8, ["readonly", "items", "rules", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      md: "4",
                      cols: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_AutoCompleteField, {
                          readonly: _ctx.isHiringmanager,
                          dense: "",
                          placeholder: "Employment Type",
                          rules: [_ctx.validations.required],
                          showRequired: "",
                          items: _ctx.employmentTypes,
                          modelValue: _ctx.model.EmploymentType,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.EmploymentType) = $event)),
                          outlined: ""
                        }, null, 8, ["readonly", "rules", "items", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "pb-0"
                    }, {
                      default: _withCtx(() => _cache[15] || (_cache[15] = [
                        _createElementVNode("span", { class: "f-body-1" }, "Company Details", -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      md: "4",
                      cols: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_TextField, {
                          readonly: _ctx.isHiringmanager,
                          dense: "",
                          placeholder: "Company Name",
                          rules: [_ctx.validations.required],
                          showRequired: "",
                          outlined: "",
                          modelValue: _ctx.model.CompanyName,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.CompanyName) = $event))
                        }, null, 8, ["readonly", "rules", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      md: "4",
                      cols: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_AutoCompleteField, {
                          readonly: _ctx.isHiringmanager,
                          outlined: "",
                          dense: "",
                          rules: [_ctx.validations.required],
                          showRequired: "",
                          items: _ctx.countries,
                          disable: _ctx.isCountryLoading,
                          loading: _ctx.isCountryLoading,
                          "item-title": "Name",
                          "item-value": "Name",
                          placeholder: "Location",
                          modelValue: _ctx.model.Location,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.Location) = $event))
                        }, null, 8, ["readonly", "rules", "items", "disable", "loading", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      md: "4",
                      cols: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_AutoCompleteField, {
                          readonly: _ctx.isHiringmanager,
                          dense: "",
                          rules: [_ctx.validations.required],
                          showRequired: "",
                          placeholder: "On Site/Remote",
                          modelValue: _ctx.model.LocationType,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.LocationType) = $event)),
                          items: _ctx.locationTypes,
                          outlined: ""
                        }, null, 8, ["readonly", "rules", "modelValue", "items"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "pb-0"
                    }, {
                      default: _withCtx(() => _cache[16] || (_cache[16] = [
                        _createElementVNode("span", { class: "f-body-1" }, "Dates", -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      md: "4",
                      cols: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DateInputField, {
                          readonly: _ctx.isHiringmanager,
                          rules: [_ctx.validations.required],
                          "first-day-of-week": "1",
                          modelValue: _ctx.model.StartDate,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.StartDate) = $event)),
                          "hide-actions": "",
                          placeholder: "Start date",
                          "prepend-icon": "",
                          max: new Date()
                        }, null, 8, ["readonly", "rules", "modelValue", "max"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      md: "4",
                      cols: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DateInputField, {
                          readonly: _ctx.isHiringmanager,
                          rules: [_ctx.validateEndDate],
                          disabled: _ctx.model.StillWorking,
                          "first-day-of-week": "1",
                          modelValue: _ctx.model.EndDate,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.EndDate) = $event)),
                          "hide-actions": "",
                          placeholder: "End date",
                          "prepend-icon": ""
                        }, null, 8, ["readonly", "rules", "disabled", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      md: "4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_switch, {
                          readonly: _ctx.isHiringmanager,
                          class: "mt-1",
                          modelValue: _ctx.model.StillWorking,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model.StillWorking) = $event)),
                          label: "Still Working"
                        }, null, 8, ["readonly", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      md: "4",
                      class: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ComboBoxField, {
                          id: "skillCombo",
                          clearable: "",
                          placeholder: "Select Skills Relevant to the Role ...",
                          label: "Skills",
                          items: _ctx.teammemberSkillList,
                          readonly: _ctx.isHiringmanager,
                          outlined: "",
                          dense: "",
                          multiple: "",
                          chips: "",
                          "item-title": "Name",
                          "item-value": "id",
                          rules: [_ctx.validations.required],
                          "closable-chips": "",
                          modelValue: _ctx.selectedSkills,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedSkills) = $event))
                        }, null, 8, ["items", "readonly", "rules", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { md: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_TextAreaField, {
                          readonly: _ctx.isHiringmanager,
                          modelValue: _ctx.model.Description,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.model.Description) = $event)),
                          outlined: "",
                          label: "Description",
                          placeholder: "Description"
                        }, null, 8, ["readonly", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_actions, { class: "justify-end" }, {
        default: _withCtx(() => [
          (!_ctx.isHiringmanager)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                class: "secondary_btn",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.cancel())),
                loading: _ctx.loading,
                "prepend-icon": "mdi-cancel"
              }, {
                default: _withCtx(() => _cache[17] || (_cache[17] = [
                  _createTextVNode(" Cancel")
                ])),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true),
          (!_ctx.isHiringmanager)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 1,
                class: "primary_btn",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.save())),
                loading: _ctx.loading,
                "prepend-icon": "mdi-check"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.model.Id == "" ? "Add Career History" : "Save Career History"), 1)
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}